import { useState } from "react";
import { useTranslation } from "react-i18next";
import Card from "../ui/Card";
import Button from "../ui/Button";
import AgreementContent from "./AgreementContent";

function AgreementSign({ onAccept, signerName, documentName }) {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleAccept = () => {
    if (!isChecked) {
      setShowError(true);
      return;
    }
    setShowError(false);
    onAccept?.();
  };

  const handleAcceptFromTerms = () => {
    setIsChecked(true);
    setShowError(false);
    setShowTerms(false);
    onAccept?.();
  };

  return (
    <>
      <div className="flex min-h-screen items-center justify-center bg-app-sand px-4">
        <Card className="w-full max-w-2xl">
          <div className="space-y-4 py-4">
            <h2 className="text-xl font-semibold text-app-ink">
              {t("term-cond-h", { defaultValue: "ELECTRONIC RECORD AND SIGNATURE DISCLOSURE" })}
            </h2>
            <p className="text-sm text-app-ink-muted">
              {t("agrrement-alert", {
                defaultValue:
                  "Debes aceptar la divulgación de firma electrónica para continuar con el proceso."
              })}
            </p>

            {(documentName || signerName) && (
              <div className="rounded-lg border border-app-line bg-app-sand p-3 text-sm text-app-ink-muted">
                {documentName ? (
                  <p>
                    <span className="font-semibold text-app-ink">
                      {t("document", { defaultValue: "Documento" })}:
                    </span>{" "}
                    {documentName}
                  </p>
                ) : null}
                {signerName ? (
                  <p className="mt-1">
                    <span className="font-semibold text-app-ink">
                      {t("for", { defaultValue: "Para" })}:
                    </span>{" "}
                    {signerName}
                  </p>
                ) : null}
              </div>
            )}

            <label className="flex items-start gap-3 rounded-lg border border-app-line bg-white p-3 text-sm text-app-ink">
              <input
                className="mt-1 h-4 w-4 rounded border-app-line text-app-brand focus:ring-app-brand/30"
                type="checkbox"
                checked={isChecked}
                onChange={(event) => {
                  setIsChecked(event.target.checked);
                  if (event.target.checked) {
                    setShowError(false);
                  }
                }}
              />
              <span>
                {t("agree-p1", {
                  defaultValue: "I confirm that I have read and understood the"
                })}{" "}
                <button
                  type="button"
                  onClick={() => setShowTerms(true)}
                  className="font-semibold text-app-brand hover:underline"
                >
                  {t("agree-p2", {
                    defaultValue: "Electronic Record and Signature Disclosure"
                  })}
                </button>{" "}
                {t("agree-p3", {
                  defaultValue: "and consent to use electronic records and signatures."
                })}
              </span>
            </label>

            {showError ? (
              <p className="text-sm text-app-danger">
                {t("agrrement-alert", {
                  defaultValue: "Debes aceptar para continuar."
                })}
              </p>
            ) : null}

            <div className="flex items-center justify-end gap-2">
              <Button variant="ghost" onClick={() => setShowTerms(true)}>
                {t("term-cond-title", { defaultValue: "Terms and conditions" })}
              </Button>
              <Button onClick={handleAccept}>
                {t("agrre-button", { defaultValue: "Agree & Continue" })}
              </Button>
            </div>

            <p className="text-xs text-app-ink-muted">
              {t("agreement-note", {
                defaultValue:
                  "Note: Agreeing to this does not mean you are signing the document immediately. This only allows you to review the document electronically. You will have the opportunity to read it in full and decide whether to sign it afterward."
              })}
            </p>
          </div>
        </Card>
      </div>

      <AgreementContent
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
        onAccept={handleAcceptFromTerms}
      />
    </>
  );
}

export default AgreementSign;
